import { axisBand } from "./axis/band-axis";

import { axisX, axisY, axisZ } from "./axis/cartesian-axis";

import { commonAxis } from "./axis/common-axis";

import { axisLinear } from "./axis/linear-axis";

import { axisAngle, axisRadius } from "./axis/polar-axis";

import { brush } from "./brush";

import { crosshair } from "./crosshair";

import { dataZoom } from "./data-zoom";

import { indicator } from "./indicator";

import { colorLegend } from "./legend/color-legend";

import { discreteLegend } from "./legend/discrete-legend";

import { sizeLegend } from "./legend/size-legend";

import { mapLabel } from "./map-label";

import { markArea } from "./mark-area";

import { markLine } from "./mark-line";

import { markPoint } from "./mark-point";

import { player } from "./player";

import { title } from "./title";

import { tooltip } from "./tooltip";

import { poptip } from "./poptip";

import { totalLabel } from "./total-label";

import { scrollBar } from "./scroll-bar";

export const component = {
    discreteLegend: discreteLegend,
    colorLegend: colorLegend,
    sizeLegend: sizeLegend,
    axis: commonAxis,
    axisBand: axisBand,
    axisLinear: axisLinear,
    axisX: axisX,
    axisY: axisY,
    axisZ: axisZ,
    axisAngle: axisAngle,
    axisRadius: axisRadius,
    markLine: markLine,
    markArea: markArea,
    markPoint: markPoint,
    polarMarkLine: markLine,
    polarMarkArea: markArea,
    polarMarkPoint: markPoint,
    geoMarkPoint: markPoint,
    tooltip: tooltip,
    dataZoom: dataZoom,
    crosshair: crosshair,
    player: player,
    brush: brush,
    indicator: indicator,
    title: title,
    mapLabel: mapLabel,
    poptip: poptip,
    totalLabel: totalLabel,
    scrollBar: scrollBar
};
//# sourceMappingURL=index.js.map
